
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_1hpp3_17qks_99",
  "arrow-outer": "awsui_arrow-outer_1hpp3_17qks_103",
  "arrow-inner": "awsui_arrow-inner_1hpp3_17qks_103",
  "arrow-position-right-top": "awsui_arrow-position-right-top_1hpp3_17qks_140",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_1hpp3_17qks_140",
  "arrow-position-left-top": "awsui_arrow-position-left-top_1hpp3_17qks_143",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_1hpp3_17qks_143",
  "arrow-position-top-center": "awsui_arrow-position-top-center_1hpp3_17qks_146",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_1hpp3_17qks_146",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_1hpp3_17qks_149",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_1hpp3_17qks_149",
  "annotation": "awsui_annotation_1hpp3_17qks_157",
  "next-button": "awsui_next-button_1hpp3_17qks_158",
  "previous-button": "awsui_previous-button_1hpp3_17qks_159",
  "finish-button": "awsui_finish-button_1hpp3_17qks_160",
  "header": "awsui_header_1hpp3_17qks_161",
  "step-counter-content": "awsui_step-counter-content_1hpp3_17qks_162",
  "content": "awsui_content_1hpp3_17qks_163",
  "description": "awsui_description_1hpp3_17qks_167",
  "actionBar": "awsui_actionBar_1hpp3_17qks_172",
  "stepCounter": "awsui_stepCounter_1hpp3_17qks_179",
  "divider": "awsui_divider_1hpp3_17qks_183",
  "hotspot": "awsui_hotspot_1hpp3_17qks_187",
  "icon": "awsui_icon_1hpp3_17qks_254"
};
  